import { render, staticRenderFns } from "./WaterwayOrIntermodalTransportation.vue?vue&type=template&id=1d3bca0a&scoped=true&"
import script from "./WaterwayOrIntermodalTransportation.vue?vue&type=script&lang=js&"
export * from "./WaterwayOrIntermodalTransportation.vue?vue&type=script&lang=js&"
import style0 from "./WaterwayOrIntermodalTransportation.vue?vue&type=style&index=0&id=1d3bca0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3bca0a",
  null
  
)

export default component.exports